import { ErrorApi } from "@/api/cliente"
import type { ErrorPago } from "./ModalPago"

/**
 * Traduce lo que lanza `api` al sobre que los modales de dinero saben pintar.
 *
 * ⚠ **Existe para que el modal no se cierre.** Sin esto cada pantalla tendría que
 * decidir por su cuenta qué hacer con un `MONTO_EXCEDE_SALDO`, y la que se
 * despistara cerraría el modal y perdería lo tecleado — que es exactamente el fallo
 * que `ModalPago` está escrito para no cometer.
 *
 * Un código que no sea de dinero se degrada a `CONFLICTO` **sin perder el mensaje**:
 * el texto del servidor es lo que explica qué pasó, y el código sólo decide el
 * encabezado. Devuelve `null` cuando no hay error, para que el modal reciba
 * `undefined | null` y no una alerta vacía.
 */
const CODIGOS_DE_DINERO: readonly ErrorPago["code"][] = [
  "MONTO_EXCEDE_SALDO",
  "SALDO_INSUFICIENTE",
  "TASA_NO_DISPONIBLE",
  "CONFLICTO",
]

export function comoErrorDeDinero(error: unknown): ErrorPago | null {
  if (!(error instanceof ErrorApi)) return null

  const code = CODIGOS_DE_DINERO.find((c) => c === error.codigo) ?? "CONFLICTO"
  return { code, message: error.message }
}
